
<div class="container-fluid">
    <div class="row g-4">
      <div class="col-12">
        <mat-card>
          <mat-card-content>
          
            <div *ngIf="isGradeList">
            <button mat-flat-button color="primary" (click)="addGrade()">
              Add Grade 
            </button>

            <button mat-flat-button color="primary" (click)="getGradeList_download()">
              Download Full List
            </button>
          </div>
           
           <div *ngIf="!isGradeList || isEdit">
            <form [formGroup]="formGroup">
             
              <!-- Contact Information Section -->
              <div lass="row g-4 mt-3">
                <div class="col-12">
                  <h6 class="section-title">Gradeformation</h6>
                </div>

              
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Grade name :</mat-label>
                    <input matInput formControlName="grade" placeholder="Enter Grade name" type="text">
                    <mat-error *ngIf="formGroup.get('grade')?.errors?.['required']">
                      Grade name is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>min_mark  :</mat-label>
                    <input matInput formControlName="min_mark" placeholder="Enter min_mark" type="number">
                    <mat-error *ngIf="formGroup.get('min_mark')?.errors?.['required']">
                      min_mark is required
                    </mat-error>
                  </mat-form-field>
                </div>
                
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>max_mark :</mat-label>
                    <input matInput formControlName="max_mark" placeholder="Enter max_mark" type="number">
                    <mat-error *ngIf="formGroup.get('max_mark')?.errors?.['required']">
                      max_mark is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>grade_point :</mat-label>
                    <input matInput formControlName="grade_point" placeholder="Enter grade_point" type="text">
                    <mat-error *ngIf="formGroup.get('grade_point')?.errors?.['required']">
                      grade_point is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>subject_type :</mat-label>
                    <input matInput formControlName="subject_type" placeholder="Enter subject_type" type="text">
                    <mat-error *ngIf="formGroup.get('subject_type')?.errors?.['required']">
                      subject_type is required
                    </mat-error>
                  </mat-form-field>
                </div>

              
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>current_grade :</mat-label>
                    <input matInput formControlName="current_grade" placeholder="Enter current_grade " type="text">
                    <mat-error *ngIf="formGroup.get('current_grade')?.errors?.['required']">
                      current_grade is required
                    </mat-error>
                  </mat-form-field>
                </div>
                
              </div>
              

              <div class="row mt-4">
                <div class="col-12">
                  <div class="d-flex gap-3">
                    <button mat-flat-button color="primary" [disabled]="isLoading " (click)="saveGrade()" class="px-4 py-2">
                      {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                    <button mat-stroked-button [disabled]="isLoading" (click)="resetForm()" class="px-4 py-2">
                      RESET
                    </button>
  
                    <button *ngIf="isEdit || !isGradeList" mat-flat-button color="primary"  (click)="back()" class="px-4 py-2">
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </mat-card-content>
      </mat-card>
      </div>
      </div>
      </div>
  
      <div *ngIf="isGradeList">
        <div class="sorting-table">
          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        
            <!-- Dynamic Columns -->
            <ng-container *ngFor="let column of displayedColumns.cols; let i = index" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ displayedColumns.label[i] | uppercase }}
              </th>
        
              <td mat-cell *matCellDef="let row; let rowIndex = index">
                <ng-container *ngIf="column === 'sno'; else otherCols">
                  {{ currentPage + (rowIndex +1)}}
                </ng-container>
                <ng-container *ngIf="column === 'createdAt'">
                    {{ row.createdAt | date:'dd/MM/yyyy'}}
                  </ng-container>
  


                <ng-template #otherCols>
                  <ng-container *ngIf="!['createdAt'].includes(column)">{{ row[column] }}</ng-container>
                  <!-- {{ row[column] }} -->
                </ng-template>
              </td>
            </ng-container>
        
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="edit(row)">
                    <mat-icon>edit</mat-icon> Edit
                  </button>
                  <button mat-menu-item (click)="delete(row)">
                    <mat-icon>delete</mat-icon> Delete
                  </button>
                </mat-menu>
              </td>
            </ng-container>
        
            <!-- Table Headers and Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns.cols.concat(['actions'])"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns.cols.concat(['actions'])"></tr>
        
          </table>
        </div>
        <mat-paginator
            [pageSizeOptions]="[5, 10, 15, 20]"
            [length]="pagination.length"
            [pageIndex]="pagination.page - 1"
            [pageSize]="pagination.limit"
            (page)="pageEvent($event)"
            *ngIf="pagination.length">
        </mat-paginator>
      </div>
      
  